import React, { useEffect, useState } from "react";
import { AdminTable } from "./AdminTable";
import { useDispatch, useSelector } from "react-redux";
import { Column } from "devextreme-react/data-grid";
import { createService, deleteService, editService, getServicesAdmin } from "../../redux/services/thunks";
import { openModal } from "../../redux/modal/modalSlice";
import { selectServiceList, selectServiceListLoading } from "../../redux/services/selectors";
import { useTranslation } from "react-i18next";

const initialSortOptions = {
    columna: "serviceId",
    sortOrderAsc: true

}

function ServiceManagement() {
    const { t } = useTranslation();
    const services = useSelector(selectServiceList);
    const dispatch = useDispatch();
    const loadingServices = useSelector(selectServiceListLoading);
    const [sortOptions, setSortOptions] = useState(initialSortOptions)

    useEffect(()=>{
        getListServices(mapPageInfo(services));

    }, [])
    
    function mapPageInfo(servicesData){
        return {
            pageIndex: servicesData.pageIndex ?? 0,
            pageSize: servicesData.pageSize ?? 15,
            orderByField:  servicesData.columna ?? "serviceId",
            orderByAscending: servicesData.sortOrderAsc ?? true
        }
    }
      
    const getListServices = (pageInfo) => {
        let query = `?pageIndex=${pageInfo.pageIndex}&pageNum=${pageInfo.pageSize}`
        if(pageInfo.searchString?.trim().length > 0){
            query = query.concat(`&searchString=${pageInfo.searchString.trim()}`)
        }
        if(pageInfo.orderByField)
            {
                query = query.concat(`&orderByField=${pageInfo.orderByField}&orderByAscending=${pageInfo.orderByAscending}`)
            }
        dispatch(getServicesAdmin({query}));
    }

    const columnsServices = [
        <Column sortIndex={1} key={"services-1"} dataType={"number"} allowEditing={false} width="8%" dataField="serviceId" caption="Id Serviço" />, 
        <Column key={"services-2"} dataType={"string"}  dataField="serviceName" caption="Nome serviço" />,
    ] 

    function handleSaveNewServiceClick(value, closeCreateModal) {   

            dispatch(createService({body:value})).then((data) => {
                    if(data.error)
                        dispatch(openModal({ type: "warning", message:data.error.message}))
                    else{
                        getListServices(mapPageInfo({...services, ...sortOptions}));
                        closeCreateModal();
                    }                    
                })
    }    

    function handleEditClick(value, closeEditModal) {

                dispatch(editService({body:value, param: value.serviceId})).then((data) => {
                    if(data.error)
                        dispatch(openModal({ type: "warning", message:data.error.message}))
                    else{
                        getListServices(mapPageInfo({...services, ...sortOptions}));
                        closeEditModal();
                    }    
                })
            }
                   
    const handleDeleteClick = (id, closeEditModal) => {
        dispatch(deleteService({param:id})).then((data) => {
            if(data.error)
                dispatch(openModal({ type: "warning", message:data.error.message}))
            else{
                let updatedPageIndex = services.pageIndex;

                if (services.elements.length === 1) {
                    updatedPageIndex = Math.max(0, services.pageIndex - 1);
                }

                const updatedServices = {
                    ...services,
                    pageIndex: updatedPageIndex,
                };

                getListServices(mapPageInfo({...updatedServices, ...sortOptions}));
                closeEditModal();               
            }
        })  
    }

    return(
        <div style={{width: "100%"}}>
            <AdminTable 
                defaultSortField={"serviceId"}
                sectionTitle={t("Services")}
                masterTitle={t("Service")}
                itemIdField={"serviceId"} 
                itemDescriptionField={"serviceName"} 
                loading={loadingServices} 
                getData={getListServices} 
                dataSource={services} 
                columnasTabla={columnsServices} 
                numElements={[15, 30, 50]} 
                onCreate={handleSaveNewServiceClick}
                onDelete={handleDeleteClick}
                onEdit={handleEditClick} 
                sortField={sortOptions}
                setsortField={setSortOptions}
            />               
        </div>
    )
}
export default ServiceManagement;